import styled from '@emotion/styled/macro';
import { BaseButton, BaseInput, forTabletPortraitDown, Variables } from '@enter/core';
import { ButtonBar } from 'components';
import { Field } from 'formik';

export const SubCategoryItem = styled.div`
    overflow: auto;
    padding: 40px;

    padding: 0px 24px;
    flex-grow: 1;
`;

export const SubCategoryH1 = styled.h1`
    font-size: 24px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n100};
`;

export const SubCategoryForm = styled.div`
    padding-bottom: 32px;
`;

export const SubCategoryCol = styled.div`
    display: flex;
    flex-direction: column;
    /* border-right: 1px solid ${Variables.Colors.platinum}; */
    min-width: 18rem;
    width: 100%;

    ${forTabletPortraitDown(`
        padding: 36px 0;
        border-right: 0;
    `)}

    &:last-of-type {
        flex-grow: 1;
    }
`;

export const SubCategoryRow = styled.div`
    display: flex;
    flex-grow: 1;

    margin-top: 10px;

    ${SubCategoryCol} &:nth-of-type(2) {
        flex-grow: 1;
    }

    ${forTabletPortraitDown(`
        flex-wrap: wrap;
        padding: 12px 24px;
    `)}
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-top: 24px;
    margin-bottom: 8px;
`;

export const Input = styled(BaseInput)`
    padding: 0 16px;
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 16px;
`;

export const FormField = styled(Field)`
    /* padding: 0 16px; */
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const InputWrapper = styled.div`
    margin-right: 10px;
    max-width: 420px;
`;

export const Buttons = styled.div``;

export const CancelButton = styled(BaseButton)``;

export const SaveButton = styled(BaseButton)`
    margin-left: 20px;
`;

export const Wrapper = styled.div`
    padding: 20px 0;
    overflow: auto;
`;
